import React from 'react';
import { Link } from 'react-router-dom';
import { BriefcaseBusiness, Building2, FileCheck2 } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import './Pricing.css';

const PLAN_ICONS = [FileCheck2, BriefcaseBusiness, Building2];

const Pricing: React.FC = () => {
  const { content } = useI18n();
  const pricing = content.pricing;
  return (
    <section className="pricing section" aria-label={pricing.aria}>
      <div className="container">
        <div className="pricing__grid">
          {pricing.plans.map((plan, index) => {
            const Icon = PLAN_ICONS[index];
            return (
              <article key={plan.name} className="pricing__card">
                <span className="pricing__icon"><Icon size={19} strokeWidth={1.7} /></span>
                <h2>{plan.name}</h2><p>{plan.description}</p>
                <ul>{plan.features.map(feature => <li key={feature}>✓ <span>{feature}</span></li>)}</ul>
                <Link to={plan.link} className="btn btn-outline">{plan.cta}</Link>
              </article>
            );
          })}
        </div>
        <p className="pricing__note">{pricing.note}</p>
      </div>
    </section>
  );
};

export default Pricing;
